import React from "react"
import PropTypes from "prop-types"
import { Typography } from "@material-ui/core"
import TypographyHtml from "../component/typography/TypographyHtml"
import DashboardElement from "../component/widgets/dashboard/DashboardElement"
import { tableTheme } from "./theme"
import useStyles from "./css"

function RowFirstColumn({ text }) {
  const classes = useStyles()
  return (
    <Typography
      variant="body1"
      color="primary"
      className={classes.tableDataSection}
    >
      {text}
    </Typography>
  )
}

function DataRow({ text }) {
  const classes = useStyles()
  return (
    <Typography variant="h4" color="secondary" className={`${classes.title}`}>
      {text}
    </Typography>
  )
}

function Disclaimer({ text }) {
  const classes = useStyles()
  const isSubtext = text.includes(" au ") // TODO: Specific text for sub-text, change in the future
  return (
    <TypographyHtml
      variant={isSubtext ? "h3" : "body1"}
      color="primary"
      className={classes.tableDataSection}
      style={{ textAlign: "center" }}
    >
      {text}
    </TypographyHtml>
  )
}

export default function FundSharePerformances(props) {
  return (
    <DashboardElement
      data={props}
      TableProps={{
        renderTitle: false,
        tableTheme,
        options: {
          responsive: "scrollFullHeight",
          elevation: 0,
          download: false,
          setRowProps: () => ({ style: { borderLeft: "1px solid blue" } })
        },
        columns: {
          // eslint-disable-next-line react/display-name
          customBodyRender: (value, tableMeta) => {
            if (tableMeta.columnIndex === 1) {
              return <RowFirstColumn text={value.text} />
            }
            return <DataRow text={value.text} />
          }
        },
        container: {
          component: "div"
        }
      }}
      TextProps={{
        component: "div",
        showTitle: false,
        // eslint-disable-next-line react/display-name
        renderText: (_, text) => <Disclaimer text={text} />,
        onEmpty: () => null
      }}
      HorizontalLayoutProps={{
        exactSplit: true,
        responsive: true
      }}
      VerticalLayoutProps={{
        exactSplit: true,
        disableSeparators: true
      }}
      disableLoader
    />
  )
}

RowFirstColumn.propTypes = {
  text: PropTypes.string.isRequired
}

DataRow.propTypes = {
  text: PropTypes.string.isRequired
}

Disclaimer.propTypes = {
  text: PropTypes.string.isRequired
}

FundSharePerformances.propTypes = {}
